import { Flex, FlexProps, Paper, PaperProps, Text } from '@mantine/core'
import React from 'react'

interface IQuizSectionTemplate extends PaperProps {
    section: number | string
    title: string
    gap?: FlexProps['gap']
    children?: React.ReactNode
}

const QuizSectionTemplate = ({
    section,
    title,
    children,
    gap = 'lg',
    ...other
}: IQuizSectionTemplate) => {
    return (
        <Paper
            my='xl'
            shadow='xl'
            p={{ xs: 'lg', lg: 50 }}
            radius='lg'
            {...other}
        >
            <Flex gap='4px' mb='lg' wrap='wrap'>
                {section && (
                    <Text fz={20} fw='bold' c='fuchasia.4'>
                        ส่วนที่ {section}
                    </Text>
                )}
                <Text fz={20} fw='bold' c='text.2'>
                    {title}
                </Text>
            </Flex>
            <Flex gap={gap} direction='column'>
                {children}
            </Flex>
        </Paper>
    )
}

export default QuizSectionTemplate
